export default __webpack_public_path__ + "static/media/2264.9bc79cc1.png";